import { render, staticRenderFns } from "./SmallDetailsOneLogo.vue?vue&type=template&id=e4d436f2&scoped=true"
import script from "./SmallDetailsOneLogo.vue?vue&type=script&lang=ts"
export * from "./SmallDetailsOneLogo.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./SmallDetailsOneLogo.vue?vue&type=style&index=0&id=e4d436f2&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)
var style1 = require("./SmallDetailsOneLogo.vue?vue&type=style&index=1&id=e4d436f2&prod&lang=css")
if (style1.__inject__) style1.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "e4d436f2",
  null
  ,true
)

export default component.exports